import axios from 'axios'
import request from '@/api/request'
import netshoes from '@/api/marketplace/netshoes'
import mercadoLivre from '@/api/marketplace/mercadoLivre'
import colombo from '@/api/marketplace/colombo'
import cnova from '@/api/marketplace/cnova'
import leroy from '@/api/marketplace/leroy'
import gfg from '@/api/marketplace/gfg'
import tiny from '@/api/erp/tiny'
import flexy from '@/api/erp/flexy'
import zoom from '@/api/marketplace/zoom'
import centauro from '@/api/marketplace/centauro'
import integracommerce from '@/api/marketplace/integracommerce'
import amazon from '@/api/marketplace/amazon'
import skyhub from '@/api/marketplace/skyhub'
import shopee from '@/api/marketplace/shopee'
import renner from '@/api/marketplace/renner'
import conectaLa from '@/api/marketplace/conectaLa'
import polishop from '@/api/marketplace/polishop'
import sicoob from '@/api/marketplace/sicoob'
import privalia from '@/api/marketplace/privalia'
import decathlon from '@/api/marketplace/decathlon'
import keepRunning from '@/api/marketplace/keepRunning'
import ramarim from '@/api/marketplace/ramarim'
import comfortflex from '@/api/marketplace/comfortflex'
import sicredi from '@/api/marketplace/sicredi'
import maisCorreios from '@/api/marketplace/maisCorreios'
import moovin from '@/api/ecommerce/moovin'
import oneeg from '@/api/ecommerce/oneeg'
import ecomece from '@/api/ecommerce/ecomece'
import tikTokShop from '@/api/marketplace/tikTokShop'
import shein from '@/api/marketplace/shein'
import magalu from '@/api/marketplace/magalu'
import { omit } from '@/helper'
import Cookie from 'vue-cookie'

export default {
  netshoes: netshoes,
  zoom: zoom,
  mercadoLivre: mercadoLivre,
  colombo: colombo,
  cnova: cnova,
  leroy: leroy,
  tiny: tiny,
  flexy: flexy,
  gfg: gfg,
  centauro: centauro,
  integracommerce: integracommerce,
  amazon: amazon,
  skyhub: skyhub,
  shopee: shopee,
  renner: renner,
  conectaLa: conectaLa,
  polishop: polishop,
  sicoob: sicoob,
  privalia: privalia,
  decathlon: decathlon,
  keepRunning: keepRunning,
  ramarim: ramarim,
  comfortflex: comfortflex,
  sicredi: sicredi,
  maisCorreios: maisCorreios,
  moovin: moovin,
  oneeg: oneeg,
  ecomece: ecomece,
  tikTokShop,
  shein: shein,
  magalu: magalu,
  /**
   * Salva produto no módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async saveProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/save`, product)).data
  },
  /**
   * Sincroniza produto com o módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async syncProduct (type, identifier, productId) {
    return (await request.get(`module/action/${type}/${identifier}/product/sync/${productId}`)).data
  },
  /**
   * Retorna erro se o produto não pode ser enviado ao marketplace.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} sku
   * @returns {Promise.<Object>}
   */
  async canProvide (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/canProvide`, product)).data
  },
  /**
   * Retorna o produto por productId no módulo desejado.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} productId
   * @returns {Promise.<Object>}
   */
  async getProduct (type, identifier, productId) {
    return (await request.get(`module/action/${type}/${identifier}/product/retrieve/${encodeURIComponent(productId)}`)).data
  },
  /**
   * Retorna o produto por productId no módulo desejado.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} id
   * @returns {Promise.<Object>}
   */
  async getProductById (type, identifier, id) {
    return (await request.get(`module/action/${type}/${identifier}/product/retrieveById/${encodeURIComponent(id)}`)).data
  },
  /**
   * Retorna o produto por sku no módulo desejado.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} sku
   * @returns {Promise.<Object>}
   */
  async getProductBySku (type, identifier, sku) {
    return (await request.get(`module/action/${type}/${identifier}/product/retrieveBySku/${encodeURIComponent(sku)}`)).data
  },
  /**
   * Retorna as marcas do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getBrands (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/brand`)).data
  },
  /**
   * Retorna as categorias do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} categoryId
   * @returns {Promise.<Object>}
   */
  async getCategories (type, identifier, categoryId) {
    if (categoryId !== undefined) {
      return (await request.get(`module/action/${type}/${identifier}/category/retrieve/${categoryId}`)).data
    }

    return (await request.get(`module/action/${type}/${identifier}/category`)).data
  },
  /**
   * Retorna as cores do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getColors (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/color`)).data
  },
  /**
   * Retorna os tamanhos do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getSizes (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/size`)).data
  },
  /**
   * Valida se os dados de autenticação são válidos.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Boolean.<Boolean>}
   */
  async checkApiStatus (type, identifier) {
    try {
      await request.get(`module/action/${type}/${identifier}/api/status`)
      return true
    } catch (err) {
      return false
    }
  },
  /**
   * Retorna os produtos do módulo em modo de listagem.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} options
   * @returns {Promise.<Object[]>}
   */
  async getProductsList (type, identifier, options) {
    return (await request.get(`module/action/${type}/${identifier}/product`, {
      params: options
    })).data
  },
  /**
   * Retorna os produtos do módulo para migração.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {string} filter
   * @param {Object} options
   * @returns {Promise.<Object[]>}
   */
  async getProductsToMigration (type, identifier, filter, options) {
    return (await request.get(`module/action/${type}/${identifier}/product/retrieveToMigration/${filter}`, {
      params: options
    })).data
  },
  /**
   * Retorna as definições dos modulos.
   *
   * @returns {Promise.<Object[]>}
   */
  async getDefinitionModules () {
    return (await request.get('module')).data
  },
  /**
   * Instala o módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async installModule (type, identifier) {
    return (await request.post(`module/install/${type}/${identifier}`)).data
  },
  /**
   * Retorna configuração do modulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getConfiguration (type, identifier) {
    return (await request.get(`module/configuration/${type}/${identifier}`)).data
  },
  /**
   * Salva configuração do modulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} configuration
   * @returns {Promise.<Object>}
   */
  async saveConfiguration (type, identifier, configuration) {
    return (await request.post(`module/configuration/${type}/${identifier}`, configuration)).data
  },
  /**
   * Ativa o módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<void>}
   */
  async activeModule (type, identifier) {
    await request.post(`module/active/${type}/${identifier}`)
  },
  /**
   * Inativa o módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<void>}
   */
  async inactiveModule (type, identifier) {
    await request.post(`module/inactive/${type}/${identifier}`)
  },
  /**
   * Retorna os pedidos em modo de listagem.
   *
   * @param {Object} options
   * @returns {Object[]}
   */
  async getOrdersList (options) {
    return (await request.get(`order/list`, {
      params: options
    })).data
  },
  /**
   * Retorna pedido por identificador do marketplace e código do pedido.
   *
   * @param {String} identifier
   * @param {String} code
   * @returns {Object}
   */
  async getOrder (identifier, code) {
    return (await request.get(`order/retrieve/marketplace/${identifier}/${code}`)).data
  },
  /**
   * Retorna os status de pedido por identificador do marketplace disponível.
   *
   * @param {String} type
   * @param {String} identifier
   * @returns {Object}
   */
  async getOrderStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/order_status/retrieve`)).data
  },
  /**
   * Atualiza informações do pedido.
   *
   * @param {String} identifier
   * @param {String} code
   * @returns {Promise.<void>}
   */
  async updateOrderInfo (identifier, code, infos) {
    return (await request.post(`order/save/marketplace/${identifier}/${code}`, infos)).data
  },
  /**
   * Atualiza informações dos itens do pedido.
   *
   * @param {String} identifier
   * @param {String} code
   * @returns {Promise.<void>}
   */
  async updateOrderItemsInfo (identifier, code, infos) {
    return (await request.post(`order/saveItems/marketplace/${identifier}/${code}`, omit(infos))).data
  },
  /**
   * Sincroniza pedido por tipo e identificador do módulo, retorna pedido sincronizado.
   *
   * @param {String} type
   * @param {String} identifier
   * @param {String} code
   * @returns {Object}
   */
  async syncOrder (type, identifier, code) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}`)).data
  },
  /**
   * Realiza a autenticação na Logarme.
   *
   * @param {String} accessToken
   * @returns {Promise<any>}
   */
  async authenticate (accessToken) {
    const headers = {
      'Authorization': accessToken
    }

    if (Cookie.get('merchant')) {
      headers['X-Merchant'] = Cookie.get('merchant')
    }

    return await axios.get(process.env.API_URL + `/authenticate`, {
      headers
    })
  },
  /**
   * Busca um usuário por token.
   *
   * @returns {Promise<void>}
   */
  async getUser () {
    return (await request.get(`user/retrieve`)).data
  },
  /**
   * Busca um usuário por token.
   *
   * @param {String} identifier
   *
   * @returns {Promise<void>}
   */
  async getMerchant (identifier) {
    return (await request.get(`merchant/retrieve/${identifier}`)).data
  },
  /**
   * Redireciona para a logarme para fazer o login.
   */
  redirectToLogarme () {
    window.location.replace(`https://app.v1.logar.me/authorize?vendor_id=e7411b44-25ea-11e8-b467-0ed5f89f718b&redirect_url=` + window.location.href)
  },
  /**
   * Redireciona para o logout da logarme.
   */
  redirectToLogoutLogarme () {
    window.location.replace(`https://app.v1.logar.me/logout?vendor_id=e7411b44-25ea-11e8-b467-0ed5f89f718b&redirect_url=` + window.location.href)
  },
  /**
   * Retorna quantidade de pedidos por status para o dashboard.
   *
   * @returns {Promise<void>}
   */
  async ordersByStatusReport (options) {
    return (await request.get(`report/ordersByStatus`, {
      params: options
    })).data
  },
  /**
   * Retorna quantidade de pedidos por marketplace para o dashboard.
   *
   * @returns {Promise<void>}
   */
  async ordersByMarketplaceAndDateReport (options) {
    return (await request.get(`report/ordersByMarketplace`, {
      params: options
    })).data
  },
  /**
   * Retorna quantidade de pedidos por etapa de despacho para o dashboard.
   *
   * @param options
   * @returns {Promise<void>}
   */
  async ordersExpeditionStepsReport (options) {
    return (await request.get(`report/ordersExpeditionSteps`, {
      params: options
    })).data
  },
  /**
   * Retorna o faturamento atual e anterior de mesmo período para o dashboard.
   *
   * @param options
   * @returns {Promise<void>}
   */
  async ordersIncomingReport (options) {
    return (await request.get(`report/ordersIncoming`, {
      params: options
    })).data
  },
  /**
   * Retorna a quantidade de produtos em cada status.
   *
   * @param options
   * @returns {Promise<void>}
   */
  async quantityProductsByStatusReport (options) {
    return (await request.get(`report/quantityProductsByStatus`, {
      params: options
    })).data
  },
  /**
   * Retorna a quantidade de preços em cada status.
   *
   * @param options
   * @returns {Promise<void>}
   */
  async quantityPricesByStatusReport (options) {
    return (await request.get(`report/quantityPricesByStatus`, {
      params: options
    })).data
  },
  /**
   * Retorna a quantidade de preços em cada status.
   *
   * @param options
   * @returns {Promise<void>}
   */
  async quantityStocksByStatusReport (options) {
    return (await request.get(`report/quantityStocksByStatus`, {
      params: options
    })).data
  },
  /**
   * Retorna os logs em modo de listagem.
   *
   * @param {Object} options
   * @returns {Object[]}
   */
  async getLogs (options) {
    return (await request.get(`log`, {
      params: options
    })).data
  },
  /**
   * Retorna os logs em modo de listagem.
   *
   * @param {Object} options
   * @returns {Object[]}
   */
  async getApiLogs (options) {
    return (await request.get(`module/action/tool/api/log`, {
      params: options,
      headers: {
        'Log-Origin': 'marketplace-api'
      }
    })).data
  },
  /**
   * Salva uma predefinição.
   *
   * @param {Object} preset
   * @returns {Promise<void>}
   */
  async addPreset (preset) {
    return (await request.post(`preset/add`, preset)).data
  },
  /**
   * Remove uma predefinição.
   *
   * @param {Object} preset
   * @returns {Promise<void>}
   */
  async deletePreset (preset) {
    return (await request.post(`preset/delete`, preset)).data
  },
  /**
   * Atualiza o status de uma predefinição.
   *
   * @param {Object} preset
   * @returns {Promise<void>}
   */
  async updateStatusPreset (preset) {
    return (await request.post(`preset/status`, preset)).data
  },
  /**
   * Retorna uma lista de predefinições.
   *
   * @returns {Promise<void>}
   */
  async getPresets () {
    return (await request.get(`preset`)).data
  },
  /**
   * Retorna os status do produto do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/statuses`)).data
  },
  /**
   * Valida se uma fonte está disponível para uma ação em lote de produto.
   *
   * @param {Object} module
   * @param {Object} source
   * @returns {Promise.<Object>}
   */
  async sourceAvailableForProduct (module, source) {
    return (await request.get(`module/action/${module.type}/${module.identifier}/task/sourceAvailableForProduct/${source.type}/${source.identifier}`)).data
  },
  /**
   * Retorna as tarefas.
   *
   * @returns {Promise.<Object>}
   */
  async getTasks (options) {
    return (await request.get(`module/action/tool/batch/task`, {
      params: options
    })).data
  },
  /**
   * Retorna uma tarefa.
   *
   * @returns {Promise.<Object>}
   */
  async getTask (id) {
    return (await request.get(`module/action/tool/batch/task/retrieve/${id}`)).data
  },
  /**
   * Salva uma tarefa.
   *
   * @returns {Promise.<Object>}
   */
  async saveTask (task) {
    return (await request.post(`module/action/tool/batch/task/save`, task)).data
  },
  /**
   * Cancela uma tarefa.
   *
   * @returns {Promise.<Object>}
   */
  async cancelTask (id) {
    return (await request.get(`module/action/tool/batch/task/cancel/${id}`)).data
  },
  /**
   * Retorna os status das tarefas.
   *
   * @returns {Promise.<Object>}
   */
  async getTaskStatuses () {
    return (await request.get(`module/action/tool/batch/task/statuses`)).data
  },
  /**
   * Cria uma tarefa de pedidos.
   *
   * @returns {Promise.<Object>}
   */
  async createPrintShipmentLabelTask (type, identifier, orders) {
    return (await request.post(`order/create_print_shipment_label_task/${type}/${identifier}`, orders)).data
  },
  /**
   * Retorna as Cargas.
   *
   * @returns {Promise.<Object>}
   */
  async getFeeds (type, identifier, options) {
    return (await request.get(`module/action/${type}/${identifier}/feed`, { params: options })).data
  },
  /**
   * Retorna uma Carga.
   *
   * @returns {Promise.<Object>}
   */
  async getFeed (identifier, feedId) {
    return (await request.get(`module/action/marketplace/${identifier}/feed/retrieve/${feedId}`)).data
  },
  /**
   * Retorna os status das Cargas.
   *
   * @returns {Promise.<Object>}
   */
  async getFeedStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/feed/statuses`)).data
  },
  /**
   * Retorna os tipos das Cargas.
   *
   * @returns {Promise.<Object>}
   */
  async getFeedTypes (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/feed/types`)).data
  },
  /**
   * Cria uma Carga.
   *
   * @returns {Promise.<Object>}
   */
  async createFeed (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/feed/create`)).data
  },
  /**
   * Cria uma Carga - Amazon.
   *
   * @returns {Promise.<Object>}
   */
  async createAmazonFeed (type, identifier, account) {
    return (await request.get(`module/action/${type}/${identifier}/feed/create`, {
      headers: {
        'Amazon-Account': account
      }
    })).data
  },
  /**
   * Retorna os status dos preços do produto do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductPriceStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/price_statuses`)).data
  },
  /**
   * Retorna os tipos dos preços do produto do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductPriceTypes (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/price_types`)).data
  },
  /**
   * Retorna as opções de filtro para disponibilidade de venda.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductSaleAvailabilities (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/sale_availabilities`)).data
  },
  /**
   * Retorna os status do estoque do produto do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductStockStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/stock_statuses`)).data
  },
  /**
   * Retorna os status da imagem do produto do módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @returns {Promise.<Object>}
   */
  async getProductImageStatuses (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/image_statuses`)).data
  },
  /**
   * Retorna as contas dos produtos do Mercado Livre.
   *
   * @returns {Promise.<Object>}
   */
  async getProductMercadoLivreAccounts () {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/accounts`)).data
  },
  /**
   * Retorna os marketplaces dos pedidos.
   *
   * @returns {Promise.<Object>}
   */
  async getOrdersMarketplaces () {
    return (await request.get(`order/retrieve_marketplaces`)).data
  },
  /**
   * Retorna as contas do mercado livre dos pedidos.
   *
   * @returns {Promise.<Object>}
   */
  async getOrdersMercadoLivreAccounts () {
    return (await request.get(`order/retrieve_mercado_livre_accounts`)).data
  },
  /**
   * Retorna as contas do shopee dos pedidos.
   *
   * @returns {Promise.<Object>}
   */
  async getOrdersShopeeAccounts () {
    return (await request.get(`order/retrieve_shopee_accounts`)).data
  },

  /**
   * Retorna os status dos pedidos no expedidor.
   *
   * @returns {Promise.<Object>}
   */
  async getOrderExpediterStatuses () {
    return (await request.get(`order/retrieve_expediter_statuses`)).data
  },
  /**
   * Retorna os usuários do hub.
   *
   * @returns {Promise.<Object>}
   */
  async getHubUsers (options) {
    return (await request.get(`user/list`, {
      params: options
    })).data
  },
  /**
   * Sincroniza um pedido com o ecommerce.
   *
   * @param code
   * @returns {Promise<*>}
   */
  async syncOrderExpediter (type, identifier, code) {
    return (await request.get(`module/action/${type}/${identifier}/order/forward/${code}`)).data
  },
  /**
   * Desvincula um pedido do expeditor.
   *
   * @returns {Promise<*>}
   */
  async unlinkOrderExpediter (type, orderId, identifierExpediter) {
    return (await request.get(`module/action/${type}/${identifierExpediter}/order/unlink/${orderId}`)).data
  },
  /**
   * Envia um arquivo.
   *
   * @returns {Promise.<Object>}
   */
  async uploadFile (formData) {
    return (await request.post(`module/action/tool/batch/file/upload`, formData)).data
  },
  /**
   * Envia uma imagem.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} formData
   * @returns {Promise.<Object>}
   */
  async uploadImage (type, identifier, formData) {
    return (await request.post(`file/upload_image_to_public_bucket/${type}/${identifier}`, formData)).data
  },
  /**
   * Atualiza o produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async updateProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/edit`, omit(product))).data
  },
  /**
   * Atualiza o preço do produto no módulo.
   *
   * @param {string} type
   * @param {string} identifier
   * @param {Object} product
   *
   * @return {Promise.<Object>}
   */
  async updateProductPrice (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/edit_price`, product)).data
  },
  /**
   * Desvincula merchant de um usuário.
   *
   * @returns {Promise.<Object>}
   */
  async unlinkUser (email) {
    return (await request.post(`user/unlink`, {
      email
    })).data
  },
  /**
   * Vincula merchant de um usuário.
   *
   * @returns {Promise.<Object>}
   */
  async linkUser (email) {
    return (await request.post(`user/link_to_merchant`, {
      email
    })).data
  },
  /**
   * Retorna acesso do usuário.
   *
   * @returns {Promise.<Object>}
   */
  async userRoleAccess () {
    return (await request.get(`user/retrieve_user_role`)).data
  },
  /**
   * Verifica se o usuário é administrador do painel.
   *
   * @returns {Promise.<Object>}
   */
  async isUserMerchantOwner () {
    return (await request.get(`user/user_merchant_owner`)).data
  },
  /**
   * Atualiza perfil de usuário.
   *
   * @returns {Promise.<Object>}
   */
  async updateUserRole (email, role) {
    return (await request.post(`user/set_role`, {
      email: email,
      role: role
    })).data
  },
  /**
   * Retorna os tokens.
   *
   * @returns {Promise.<Object>}
   */
  async getTokens (options) {
    return (await request.get(`module/action/tool/api/token`, {
      params: options
    })).data
  },
  /**
   * Retorna todos os tokens sem paginação.
   *
   * @returns {Promise.<Object>}
   */
  async getAllTokens () {
    return (await request.get(`module/action/tool/api/token/list`)).data
  },
  /**
   * Retorna um token.
   *
   * @returns {Promise.<Object>}
   */
  async getToken (id) {
    return (await request.get(`module/action/tool/api/token/retrieve/${id}`)).data
  },
  /**
   * Salva um token.
   *
   * @returns {Promise.<Object>}
   */
  async saveToken (token) {
    return (await request.post(`module/action/tool/api/token/create`, token)).data
  },
  /**
   * Edita um token.
   *
   * @returns {Promise.<Object>}
   */
  async editToken (token) {
    return (await request.post(`module/action/tool/api/token/edit`, token)).data
  },
  /**
   * Altera o status do token.
   *
   * @returns {Promise.<Object>}
   */
  async changeStatusToken (token) {
    return (await request.post(`module/action/tool/api/token/status`, token)).data
  },
  async getOrderShippingMethods (expediterType, expediterIdentifier) {
    return (await request.get(`order/retrieve_shipping_methods/${expediterType}/${expediterIdentifier}`)).data
  },
  /**
   * Retorna os métodos de envio do marketplace.
   *
   * @param identifier
   *
   * @returns {Promise<String[]>}
   */
  async getMarketplaceShippingMethods (identifier) {
    return (await request.get(`order/retrieve_marketplace_shipping_methods/marketplace/${identifier}`)).data
  },
  /**
   * Retorna os gêneros dos produtos do módulo.
   *
   * @param type
   * @param identifier
   *
   * @returns {Promise<String[]>}
   */
  async getGenders (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/gender`)).data
  },

  /**
   * Retorna as faixas etária dos produtos do módulo.
   *
   * @param type
   * @param identifier
   *
   * @returns {Promise<String[]>}
   */
  async getAgeGroups (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/age_group`)).data
  },

  /**
   * Retorna o range de preço mínimo e máximo dos produtos do módulo.
   *
   * @param type
   * @param identifier
   *
   * @returns {Promise<Object>}
   */
  async getPriceLessAndHighest (type, identifier) {
    return (await request.get(`module/action/${type}/${identifier}/product/price_less_and_highest`)).data
  },

  /**
   * Retorna as modalidade de entrega que o serviço de frete possui.
   *
   * @param identifier
   *
   * @returns {Promise<*>}
   */
  async getShippingMethods (identifier) {
    return (await request.get(`module/action/shipment/${identifier}/shipping_method`)).data
  },

  /**
   * Retorna uma lista atributos do marketplace.
   *
   * @param identifier
   * @param options
   *
   * @returns {Promise<*>}
   */
  async getAttributes (identifier, options) {
    return (await request.get(`module/action/marketplace/${identifier}/attribute`, {
      params: options
    })).data
  },

  /**
   * Retorna um atributo do marketplace.
   *
   * @param identifier
   * @param attributeId
   *
   * @returns {Promise<*>}
   */
  async getAttribute (identifier, attributeId) {
    return (await request.get(`module/action/marketplace/${identifier}/attribute/retrieve/${attributeId}`)).data
  },

  /**
   * Adiciona ou atualiza um atributo do marketplace.
   *
   * @param attribute
   * @param identifier
   *
   * @returns {Promise<*>}
   */
  async saveAttribute (attribute, identifier) {
    return (await request.post(`module/action/marketplace/${identifier}/attribute/save`, attribute)).data
  },

  /**
   * Remove um atributo do marketplace.
   *
   * @param attributeId
   * @param identifier
   *
   * @returns {Promise<*>}
   */
  async removeAttribute (attributeId, identifier) {
    return (await request.get(`module/action/marketplace/${identifier}/attribute/remove/${attributeId}`)).data
  },
  /**
   * Retorna o histórico de alteração de preço do sku informado.
   *
   * @param sku
   * @param type
   * @param identifier
   * @param filters
   *
   * @returns {Promise<*>}
   */
  async retrievePriceHistory (sku, type, identifier, filters) {
    return (await request.get(`module/action/${type}/${identifier}/history_price/retrieve/${sku}`, {
      params: filters
    })).data
  },
  /**
   * Retorna os produtos para migração.
   *
   * @param type
   * @param identifier
   * @param options
   * @param account
   * @returns {Promise<void>}
   */
  async getProductsMigration (type, identifier, options, account) {
    return (await request.get(`module/action/${type}/${identifier}/product_migration`, {
      params: options
    })).data
  },
  /**
   * Retorna os detalhes de um anúncio de migração.
   *
   * @param type
   * @param identifier
   * @param sku
   * @returns {Promise<void>}
   */
  async getProductsMigrationDetails (type, identifier, sku) {
    return (await request.get(`module/action/${type}/${identifier}/product_migration/retrieve/${sku}`)).data
  },
  /**
   * Salva um produto migrado.
   *
   * @param type
   * @param identifier
   * @param product
   * @returns {Promise<void>}
   */
  async saveProductMigration (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product_migration/save`, product)).data
  },
  /**
   * Reprocessa preço ou estoque de produtos nos marketplaces.
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async reprocess (type, identifier, options) {
    return (await request.post(`module/action/${type}/${identifier}/reprocess`, {
      params: options
    })).data
  },
  /**
   * Reprocessa imagens de produtos nos marketplaces.
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async reprocessImages (type, identifier, options) {
    return (await request.post(`module/action/${type}/${identifier}/reprocess/reprocessImages`, {
      params: options
    })).data
  },
  /**
   * Inativa um produto anunciado
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async deactivateProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/deactivate`, product)).data
  },
  /**
   * Remover um produto do Place->marketplace
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async removeProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/remove`, product)).data
  },
  /**
   * Reenvia um produto anunciado
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async resendProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/resend`, product)).data
  },
  /**
   * Reativa um produto anunciado
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async reactivateProduct (type, identifier, product) {
    return (await request.post(`module/action/${type}/${identifier}/product/reactivate`, product)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js